(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsToggle', rmsToggle);

    function rmsToggle() {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {},
            transclude: true,
            template: `<label><button type="button" ng-click="toggleButton()" class="button blue hollow default-button checkbox-fa small"><span><i class="fa" ng-class="{\'fa-check\':toggleData}"></i></span></button><span><ng-transclude></ng-transclude></span></label>`,
            link: rmsToggleLink
        };

        function rmsToggleLink(scope, elem, link, ngModelCtrl) {
            ngModelCtrl.$formatters.push(function(modelValue) {
                if (modelValue === undefined) {
                    return false;
                }
                return modelValue;
            });

            ngModelCtrl.$render = function() {
                scope.toggleData = ngModelCtrl.$viewValue;
            };

            scope.toggleButton = function() {
                scope.toggleData = !scope.toggleData;
                ngModelCtrl.$setViewValue(scope.toggleData);
            }
        }
    }
})();